export default __webpack_public_path__ + "static/media/KOD0004-min.a6c11b20.webp";